import(/* webpackMode: "eager" */ "/app/apps/portal-play/src/app/error.tsx");
import(/* webpackMode: "eager" */ "/app/apps/portal-play/src/components/atoms/RNStyleProvider/index.tsx");
import(/* webpackMode: "eager" */ "/app/apps/portal-play/src/modules/ClientSideHead/index.tsx");
import(/* webpackMode: "eager" */ "/app/apps/portal-play/src/modules/ThemeHandler/index.tsx");
import(/* webpackMode: "eager" */ "/app/apps/portal-play/src/styles/globals.css")